export const items = [
  [
         {
      name: 'MSPs',
      icon: '/UserActivity.svg',
      link: '/partners/msps'
    },
    {
      name: 'MSSPs',
      icon: '/RemoteManagement.svg',
      link: '/partners/mssps'
    },
       {
      name: 'VARs',
      icon: '/PerformanceMonitoring.svg',
      link: '/partners/vars'
    },
  ]
];

export const label = 'Partners';
